import { Routes } from '@angular/router';

export const phoneVerificationRoutes: Routes = [
  {
    path: 'verify-phone',
    loadComponent: () =>
      import('../features/phone-verification/verify-phone/verify-phone.component').then(
        (m) => m.VerifyPhoneComponent
      ),
  },
];
